import {
  useEnabledFeatures as enabledFeaturesHook,
  useFlag as flagHook,
} from '@calendly/feature-check-react'

import { PRODUCT_REFRESH_GLOBAL_OPT_IN_DISABLED_FLAG_KEY } from '../../../core/app_shell_feature_flags'

/**
 * Rollout flag (`ap_product_refresh_2026_global_opt_in_disabled`) that skips the
 * early-access opt-in requirement and enables product refresh for the cohort.
 */
export function useProductRefreshGlobalOptInDisabled(): boolean {
  const enabledFeatures = typeof enabledFeaturesHook === 'function'
    ? enabledFeaturesHook()
    : {}
  const fromBootstrap = enabledFeatures[PRODUCT_REFRESH_GLOBAL_OPT_IN_DISABLED_FLAG_KEY] === 'on'
  const fromFlag = typeof flagHook === 'function'
    ? flagHook(PRODUCT_REFRESH_GLOBAL_OPT_IN_DISABLED_FLAG_KEY, true)
    : false
  return fromBootstrap || fromFlag
}
